import request from '@/utils/request'

/**
 * 获取OSS上传签名，通过role区分个人/学校用户
 */
export function aliOss(data) {
  const role = window.localStorage.getItem("role") || "31";
  return request({
    url: 'api/signature/oss',
    method: 'post',
    data: { ...data, role: Number(role) }
  })
}